import EventDrawerView from './EventDrawerView';

export default EventDrawerView;
